import {
    type DeleteSystemLocaleResponseType,
    type DeleteSystemLocaleRequestType
} from "./type";
import {
    request
} from "../request";

const deleteSystemLocale = async (params: DeleteSystemLocaleRequestType): Promise<DeleteSystemLocaleResponseType> => {
    return await request<DeleteSystemLocaleResponseType>("/systemLocale/deleteSystemLocale", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default deleteSystemLocale;
